module.exports = __webpack_public_path__ + "assets/img/22_1333_big.77cf0cb5.jpg";